export default __webpack_public_path__ + "static/media/client-like.e6034d12.svg";